import { FC } from "react";
import { Content } from "@prismicio/client";
import { SliceComponentProps } from "@prismicio/react";
import Weave  from '../../assets/images/weave.svg'

/**
 * Props for `LineSeparator`.
 */
export type LineSeparatorProps =
  SliceComponentProps<Content.LineSeparatorSlice>;

/**
 * Component for "LineSeparator" Slices.
 */
const LineSeparator: FC<LineSeparatorProps> = ({ slice }) => {

  let lineColour = ""
  switch(slice.primary.single_line_color) {
    case "Grey" :
      lineColour = "bg-grey"
    break;
    case "Jade" :
      lineColour = "bg-jade"
    break;
    case "Orange" :
      lineColour = "bg-orange"
    break;
    case "White":
      lineColour = "bg-white"
    break;
  }
  return (
    <section
      data-slice-type={slice.slice_type}
      data-slice-variation={slice.variation}
      className="w-full py-16"
    >
    {slice.primary.line_type === "Single Line" ?
      <div className={`${lineColour} w-full h-[1px] max-w-[1280px] mx-auto px-4 md:px-8 lg:px-12`}></div>
    :
      <div className="w-full mx-auto mb-8">
          <Weave />
      </div>
    }
    </section>
  );
};

export default LineSeparator;
